import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon } from 'lucide-react-native';
import { memo } from 'react';
import { ActivityIndicator, TouchableOpacity } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** A wide button of the report's actions, filled or outlined. */
export const AgainButton = memo(
  ({
    title,
    icon: Icon,
    primary,
    busy,
    disabled,
    onPress,
  }: {
    title: string;
    icon: LucideIcon;
    primary: boolean;
    busy: boolean;
    disabled: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const color = primary ? aiColors.primaryForeground : aiColors.foreground;
    return (
      <TouchableOpacity
        accessibilityRole="button"
        disabled={disabled}
        onPress={onPress}
        style={{
          flex: 1,
          height: rpx(44),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: rpx(6),
          borderRadius: rpx(12),
          borderWidth: primary ? 0 : 1,
          borderColor: aiColors.border,
          backgroundColor: primary ? aiColors.primary : aiColors.card,
          opacity: disabled && !busy ? 0.6 : 1,
        }}
      >
        {busy ? (
          <ActivityIndicator size="small" color={color} />
        ) : (
          <Icon size={rpx(16)} color={color} />
        )}
        <Typography.Text size={rpx(14)} bold color={color}>
          {title}
        </Typography.Text>
      </TouchableOpacity>
    );
  },
);
